import React from 'react';
import ServicePage from '../../components/ServicePage';

const SeniorMoving = () => (
  <ServicePage
    seoTitle="Senior Moving Services in Washington | Navy Seals Moving"
    seoDescription="Patient, respectful moving services for seniors and their families. Family-owned with 20+ years of experience. One dedicated crew handles everything, from careful packing to setup at the new home."
    headerTitle="Senior Moving Services"
    introTitle="Moving Services Designed Around Seniors"
    intro={[
      "Moving after decades in the same home is a big step, often with a lifetime of belongings, memories, and decisions attached. Our crews are chosen for this work because they are patient, respectful, and careful: we take the time to do it right, and we treat your belongings and your home the way we would our own family's.",
      "As a family-owned company with over 20 years of experience, we handle every senior move with one dedicated team from start to finish. The same crew that packs your home is the crew that delivers and places everything in the new one, whether that's across town, into a retirement community, or across the country to be closer to family.",
      "We work at your pace, coordinate with family members near or far, and provide accurate estimates by video call or an in-person visit, no surprises on moving day."
    ]}
    featuresTitle="What We Take Care Of"
    features={[
      {
        icon: 'icon_group',
        title: 'One Patient, Dedicated Crew',
        text: 'The same experienced team handles your entire move (packing, loading, transport, and placement) so you deal with familiar faces, not strangers at every stage.'
      },
      {
        icon: 'icon_house',
        title: 'Careful Packing & Setup',
        text: 'We pack fragile keepsakes, furniture, and everyday items with premium materials, and at your new home we place furniture and boxes exactly where you want them.'
      },
      {
        icon: 'icon_easel',
        title: 'Downsizing & Storage Options',
        text: 'Not everything has to move at once. Our secure, climate-controlled warehouse can hold furniture and belongings for as long as you need while decisions get made.'
      },
      {
        icon: 'icon_datareport',
        title: 'Family Coordination',
        text: 'Adult children arranging a move for a parent? We keep the whole family informed, coordinate schedules, and provide the estimate and updates to whoever manages the move.'
      }
    ]}
  />
);

export default SeniorMoving;
